/**
 * Which bubbles wear the delivered/read mark and its "Seen by" card.
 *
 * - `all` — every bubble, the office thread's view: staff see who read anything.
 * - `own` — only the viewer's own messages, the household's view: a homeowner sees whether
 *   THEIR message reached the team, and nothing about who read anyone else's.
 * - `off` — none, for surfaces with no read state worth showing (internal notes, threads).
 */
export type ReadReceiptMode = "all" | "own" | "off";

/**
 * Whether one bubble shows the mark under a surface's mode.
 *
 * @param mode - The surface's resolved mode.
 * @param authorId - The message's `userCreatedId`.
 * @param viewerId - The signed-in user; absent while `me` loads, which shows nothing under `own`.
 */
export function showsReadReceipt(
  mode: ReadReceiptMode,
  authorId: string,
  viewerId: string | undefined,
): boolean {
  if (mode === "all") return true;
  if (mode === "off") return false;
  return !!viewerId && authorId === viewerId;
}
